import type { AgentIntegrations } from "replo-publisher/src/trpc/routers/agentIntegrations";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: agentIntegrationsRouter,
  client: agentIntegrationsClient,
  utils: agentIntegrationsUtils,
  options: agentIntegrationsOptions,
} = createTrpcRouterConfig<AgentIntegrations>({
  path: "agentIntegrations",
  queryClient: getNamespacedQueryClient("agentIntegrations"),
});

export {
  agentIntegrationsClient,
  agentIntegrationsRouter,
  agentIntegrationsUtils,
  agentIntegrationsOptions,
};
